<template>
  <InputContainer :read-only="!store.isEditable">
    <template #label>{{ $t('From date') }}</template>
    <template #sub-label>{{ $t('The first billable day') }}</template>
    <template #read-only>{{ store.paymentRequestForm.dateStart }}</template>
    <PickerDatetime
      v-model="store.paymentRequestForm.dateStart"
      data-test="payment-request-date-start-picker"
      name="date_start"
      format="YYYY-MM-DD"
      :error="validationStore.v$.dateStart.$errors?.[0]?.$message as string"
      @update:model-value="validationStore.v$.dateEnd.$touch()"
      @blur="validationStore.v$.dateStart.$touch()"
    />
  </InputContainer>
  <InputContainer :read-only="!store.isEditable">
    <template #label>{{ $t('To date') }}</template>
    <template #sub-label>{{ $t('The last billable day') }}</template>
    <template #read-only>{{ store.paymentRequestForm.dateEnd || $t('None') }}</template>
    <PickerDatetime
      v-model="store.paymentRequestForm.dateEnd"
      data-test="payment-request-date-end-picker"
      name="date_end"
      format="YYYY-MM-DD"
      :min-date="store.paymentRequestForm.dateEnd ? store.paymentRequestForm.dateStart : ''"
      :error="validationStore.v$.dateEnd.$errors?.[0]?.$message as string"
      @blur="validationStore.v$.dateEnd.$touch()"
    />
  </InputContainer>
</template>

<script setup lang="ts">
import InputContainer from '@/components/PaymentRequest/InputContainer.vue'
import PickerDatetime from '@/components/PickerDatetime.vue'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import { useTranslation } from '@/composables/translation'
import { useValidationStore } from '@/components/PaymentRequest/store/useValidationStore'

const { $t } = useTranslation()
const store = usePaymentRequestStore()
const validationStore = useValidationStore()
</script>
